import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import qrcode from 'qrcode'

import { 
  tryToFetchMyAccountInfo,
  tryToSetupEmailMFA,
  tryToSetupAppMFA,
  tryToEnableEmailMFA, 
  tryToEnableAppMFA,
  tryToDisableEmailMFA, 
  tryToDisableAppMFA,
} from '../../actions/actions.export.js';

import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import CustomField from '../CustomField/CustomField.js'
import MFAPinField from '../MFAPinField/MFAPinField.js'

class UserSettingsPasswordMFAForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
    }
  }

  componentWillMount(){
    const { dispatch, user } = this.props;
    if(!user.tryingToFetchMyAccountInfo){
      dispatch(tryToFetchMyAccountInfo());
    }
  }

  componentWillReceiveProps(newprops){
    const { user } = newprops;
    const { change } = this.props;

    if(user.mfa_qr_code_url){
      qrcode.toDataURL(user.mfa_qr_code_url, (err, url) => {
        this.setState({
          qrcode_data_url: url
        })
      })
    }

    this.setState({
      // mfa_enabled: newprops.user.mfa_enabled,
      // mfa_method_email_enabled: newprops.user.mfa_method_email_enabled
    })
  }


  render(){
    const { dispatch, user } = this.props; 
    const state = this.state;

    let formDisabled = !state.current_password || !state.new_password || !state.new_password_verify;



    return (
      <div>
       
        {
          user.mfa_email_enabled || user.mfa_app_enabled ? 
          <div>
            <p className=" text-success">
              <i className="fa fa-check"/> Two-factor authentication is currently enabled.
            </p>
            {
              (user.mfa_email_enabled && user.mfa_app_enabled) && <p className="text-small">You will be able to choose which method to use each time you log in.</p>
            }
          </div>
          :
          <div>
            <p className="">
              Two-factor authentication is not enabled, choose a method below to get started.
            </p>
          </div>
        }
        <hr/>

        <div className="flex-split small-margin-bottom">
          <div className="expand small-padding text-thin-line-height">
            {
              user.mfa_email_enabled && <span><i className="fas fa-check text-success"/>&nbsp;&nbsp;</span>
            }
            <strong>Email</strong><br/>
            <small><i className="translucent">{user.email}</i></small>
          </div>
          {
            user.mfa_email_enabled ? 
            <Button 
              display={"Disable"}
              color="danger"
              onClick={() => {
               dispatch(tryToDisableEmailMFA())
              }}
              thinking={user.tryingToDisableEmailMFA}
              failed={user.failedToDisableEmailMFA}
              successful={user.successfullyDisabledEmailMFA}
              />
            :
            <Button 
              display={this.state.setting_up_email ? "Cancel" : "Setup"}
              color="grey"
              onClick={() => {
                if(this.state.setting_up_email){
                  this.setState({
                    setting_up_email: false
                  })
                } else {
                  this.setState({
                    setting_up_email: true,
                    qrcode_data_url: undefined
                  })
                }
              }}
              block={true}
              />
          }
        </div>

        {
          (state.setting_up_email && !user.mfa_email_enabled) &&
          <div className="mfa-qr">
            <p className="text-small">
              Click the button below to get an code sent to your email address at <strong>{user.email}</strong>. Enter the 6-digit code to complete 2FA setup.
            </p>
            <div className="flex-split">
              <Button 
                display="Send Code"
                color="grey"
                onClick={() => {
                  dispatch(tryToSetupEmailMFA())
                }}
                block={true}
                thinking={user.tryingToSetupEmailMFA}
                failed={user.failedToSetupEmailMFA}
                successful={user.successfullySetupEmailMFA}
                />
              
              <div className="flex-center-column">
                <MFAPinField onComplete={(code) => {
                    dispatch(tryToEnableEmailMFA({code: code}))
                  }}
                  thinking={user.tryingToEnableEmailMFA}
                  failed={user.failedToEnableEmailMFA}
                  successful={user.successfullyEnabledEmailMFA}
                  />
              </div>
            </div>
          </div>
        }
        <hr/>

        <div className="flex-split small-margin-bottom">
          <div className="expand small-padding text-thin-line-height">
            {
              user.mfa_app_enabled && <span><i className="fas fa-check text-success"/>&nbsp;&nbsp;</span>
            }
            <strong>Authenticator Mobile App</strong><br/>
            <small><i className="translucent">(i.e. Google Authenticator, Duo Mobile, etc)</i></small>
          </div>
          {
            user.mfa_app_enabled ? 
            <Button 
              display={"Disable"}
              color="danger"
              onClick={() => {
                dispatch(tryToDisableAppMFA())
              }}
              thinking={user.tryingToDisableAppMFA}
              failed={user.failedToDisableAppMFA}
              successful={user.successfullyDisabledAppMFA}
              />
            :

            <Button 
              display={state.qrcode_data_url ? "Cancel" : "Setup"}
              color="grey"
              block={true}
              onClick={() => {
                if(state.qrcode_data_url){
                  this.setState({
                    qrcode_data_url: undefined
                  })
                } else {
                  this.setState({
                    setting_up_email: false
                  })
                  dispatch(tryToSetupAppMFA())
                }
              }}
              thinking={user.tryingToSetupAppMFA}
              failed={user.failedToSetupAppMFA}
              successful={user.successfullySetupAppMFA}
              />
          }
        </div>
        {
          (state.qrcode_data_url && !user.tryingToSetupAppMFA && !user.mfa_app_enabled) && <div className="mfa-qr">
            <p className="text-small">
              Scan this code using your mobile authentication app and enter a 6-digit 2FA pin to complete setup. Once setup, you can use your app to generate a code anytime.
            </p>
            <div className="flex-split">
              <img src={state.qrcode_data_url}/>
              <div className="flex-grow-1 flex-center-column">
                <MFAPinField onComplete={(code) => {
                    dispatch(tryToEnableAppMFA({code: code}))
                  }}
                  thinking={user.tryingToEnableAppMFA}
                  failed={user.failedToEnableAppMFA}
                  successful={user.successfullyEnabledAppMFA}
                  />
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}


UserSettingsPasswordMFAForm = reduxForm({
  form: 'UserSettingsPasswordMFAForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(UserSettingsPasswordMFAForm)

UserSettingsPasswordMFAForm = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {};
  
  return {
    user,
    initialValues
  }
})(UserSettingsPasswordMFAForm);

export default UserSettingsPasswordMFAForm;


// WEBPACK FOOTER //
// ./src/components/UserSettingsMFAForm/UserSettingsMFAForm.js